import type React from "react";
import { ReactComponent as Svg } from "./assets/circle-arrow-down.svg";
import * as styles from "./Icon.module.scss";

type CircleArrowDownProps = React.SVGProps<SVGSVGElement>;

export const CircleArrowDown = ({ className, ...props }: CircleArrowDownProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
